import { useEffect } from "react"
import useSidebarContent from "../../hooks/useSidebarContent"

export default function PageSidebarContent({ children }) {
  const { setSidebarContent, clearSidebarContent } = useSidebarContent()

  useEffect(() => {
    setSidebarContent(children)

    return () => {
      clearSidebarContent()
    }
    // Intentionally mount/unmount only: tracking `children` causes loops
    // because JSX nodes are recreated by parent renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
